/**
 * Parse a float value from a string. If the parse fails, we return the default value instead.
 *
 * This is useful for dealing with the strings returned by `<input>`s.
 */ export function parseFloatOrFallback(value, defaultValue) {
    try {
        const parsedValue = parseFloat(value);
        return isNaN(parsedValue) ? defaultValue : parsedValue;
    } catch (e) {
        return defaultValue;
    }
}

//# sourceMappingURL=utils.js.map